export default "__VITE_ASSET__CSOPHRrw__"